import React from "react";
import SectionsData from "modules/shared/profiles/SectionsData";
import { SectionContainer } from "./ViewPersonalIfon";
import { LICENSE } from "../staticData";

function ViewWorkingInfo({ data }) {
    return (
        <SectionContainer>
            <SectionsData
                label="Working Governorate"
                text={data?.attributes?.workingGovernorates
                    ?.map((governorate) => governorate?.name)
                    .join("-")}
            />
            <SectionsData
                label="Preferred Truck Types"
                text={data?.attributes?.truckTypes?.join("-")}
            />
            <SectionsData
                label="Driving License Expiration"
                text={data?.attributes?.licenseExpiryDate}
            />
            <SectionsData
                label="Driving License Photo"
                image={data?.attributes?.driverLicense}
            />
            <SectionsData
                label="Driving license type "
                text={LICENSE.find((obj) => obj.value === data?.attributes?.licenseType)?.label}
            />
            <SectionsData
                label="Supplier"
                text={data?.supplier}
            />
        </SectionContainer>
    );
}

export default ViewWorkingInfo;
